import {NotificationSettingsPage} from "./NotificationSettingsPage";

export default NotificationSettingsPage;